import { SVG, SVGProps } from './svg'

export function IconCaretLeft(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M13.5 6.2a.7.7 0 0 1 1 0l.3.3.2.5v10c0 .2 0 .4-.2.5l-.3.3a.7.7 0 0 1-1 0l-5.3-5.3a.7.7 0 0 1 0-1l5.3-5.3Z" />
    </SVG>
  )
}
